import {HTMLAttributes, ReactNode} from 'react';
import {Loading} from '../../../design-system/atoms/Loading/Loading';
import {getSerializedPagewebError} from '../../../errors/getSerializedPagewebError.function';
import {PagewebError} from '../../../errors/PagewebError.class';
import {useDeviceInfoQuery} from '../../../wrapper/deviceWrapper';

interface DeviceInfoFetcherHeadlessProps
  extends HTMLAttributes<HTMLDivElement> {
  children: ReactNode;
}

export function DeviceInfoFetcherHeadless({
  children,
  ...props
}: DeviceInfoFetcherHeadlessProps) {
  const {error, isLoading} = useDeviceInfoQuery();

  if (isLoading) {
    return (
      <div className="flex-center-full">
        <Loading />
      </div>
    );
  }

  if (error) {
    throw new PagewebError(getSerializedPagewebError(error));
  }

  return <div {...props}>{children}</div>;
}
